import { Outlet, ScrollRestoration, useMatches } from 'react-router-dom';
import styles from './MainLayout.module.scss';
import SiteHeader from '@/shared/components/SiteHeader';
import SiteFooter from '@/shared/components/SiteFooter';
import { PWAInstallPrompt } from '@/shared/components/PWAInstallPrompt';

/** `handle: { ds: 'nebi' }` numa rota a marca como já migrada. */
type RouteHandle = { ds?: 'nebi' | 'legacy' };

export const MainLayout = () => {
  const matches = useMatches();

  // Sem `handle: { ds: 'nebi' }`, o miolo fica travado no Pergaminho (hex fixos do design antigo).
  const leaf = matches[matches.length - 1];
  const ds = (leaf?.handle as RouteHandle | undefined)?.ds === 'nebi' ? 'nebi' : 'legacy';

  return (
    <div className={styles.mainLayout}>
      <ScrollRestoration />
      <SiteHeader />

      <main className={styles.content} data-ds={ds}>
        <Outlet />
      </main>

      <SiteFooter />
      <PWAInstallPrompt />
    </div>
  );
};

export default MainLayout;
